// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"user_shadow__2eRjW","cell":"user_cell__2Hdi4","row":"user_row__vR09w"};